export default __webpack_public_path__ + "static/media/arbonne.7ef14b8e.jpg";